import { Html } from "@react-three/drei";

const Final = (props) => {
  return (
    <>
      <Html className="page" {...props} fullscreen zIndexRange={[0, 0]}>
        {props.visible ? (
          <>
            <img src="./logo_white.png" alt="cybertruck-logo" height="120rem" />
            <p
              style={{
                position: "absolute",
                bottom: 0,
                fontSize: "0.8rem",
                textAlign: "center",
              }}
            >
              {"Made with ❤️ by StreetLamb"}
              <br />
              {"Cybertruck model by hashikemu"}
            </p>
          </>
        ) : null}
      </Html>
    </>
  );
};

export default Final;
